
const CustomerSearch = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/CustomerSearch")
const CustomerDetail = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/CustomerDetail")
const CustomerDetailInformation = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailInformation")
const CustomerDetailUsages = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailUsages")
const CustomerDetailInvoices = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailInvoices")
const CustomerDetailFreeChargingPoints = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailFreeChargingPoints")
const CustomerDetailLoginToAccount = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailLoginToAccount")
const CustomerDetailRfid = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailRfid")
const CustomerDetailReviews = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailReviews")
const CustomerDetailPaymentMethods = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailPaymentMethods")
const CustomerDetailEdit = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailEdit")
const CustomerDetailSessionAuthorizations = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailSessionAuthorizations.vue")
const CustomerTransactions = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerTransactions.vue")
const CustomerAdd = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/CustomerAdd")
const CustomerDetailLoginHistory = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailLoginHistory")
const CustomerDetailVehicles = () => import(/* webpackChunkName: "customer" */ "@pages/Customer/Detail/CustomerDetailVehicles")

export default [
  {
    name: 'customers',
    path: 'customers',
    component: CustomerSearch,
  },
  {
    name: 'customer.add',
    path: 'customer/add',
    component: CustomerAdd,
  },
  {
    path: 'customer/:id',
    component: CustomerDetail,
    children: [
      {
        name: 'customer.detail',
        path: '',
        component: CustomerDetailInformation,
      },
      {
        name: 'customer.edit',
        path: 'edit',
        component: CustomerDetailEdit,
      },
      {
        name: 'customer.detail.usages',
        path: 'usages',
        component: CustomerDetailUsages,
      },
      {
        name: 'customer.detail.free-charging-points',
        path: 'free-charging-points',
        component: CustomerDetailFreeChargingPoints,
      },
      {
        name: 'customer.detail.login-to-account',
        path: 'login-to-account',
        component: CustomerDetailLoginToAccount,
      },
      {
        name: 'customer.detail.invoices',
        path: 'invoices',
        component: CustomerDetailInvoices,
      },
      {
        name: 'customer.detail.rfid',
        path: 'rfid',
        component: CustomerDetailRfid,
      },
      {
        name: 'customer.detail.reviews',
        path: 'reviews',
        component: CustomerDetailReviews,
      },
      {
        name: 'customer.detail.payment-methods',
        path: 'payment-methods',
        component: CustomerDetailPaymentMethods,
      },
      {
        name: 'customer.detail.authorizations',
        path: 'authorizations',
        component: CustomerDetailSessionAuthorizations,
      },
      {
        name: 'customer.detail.transactions',
        path: 'transactions',
        component: CustomerTransactions,
      },
      {
        name: 'customer.detail.vehicles',
        path: 'vehicles',
        component: CustomerDetailVehicles,
      },
      {
        name: 'customer.detail.logins',
        path: 'logins',
        component: CustomerDetailLoginHistory,
      },
    ]
  },
]